import { WorkOrderItemType } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import { WorkOrderItemData } from '../index';
import { useWorkorderDetailContext } from '../../../WorkorderDetailProvider';
import {
  WorkOrderComplement,
  WorkOrderComplementStatus,
} from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { ReactNode } from 'react';

interface Props {
  item: WorkOrderItemData;
  onClick?: VoidFunction;
  children?: ReactNode;
  permission?: boolean;
  complementOverride?: WorkOrderComplement;
}

export default function WorkOrderItemSpan(props: Props) {
  const detailCtx = useWorkorderDetailContext();
  const complement =
    props.complementOverride ?? detailCtx?.complement?.data;

  const isAuthorized =
    complement?.status === WorkOrderComplementStatus.Authorized &&
    !hasPermissions([Authorities.MOVIMENTATION_WORKORDER_AUTHORIZED_EDIT_ITEM]);
  const isOpen =
    complement?.status === WorkOrderComplementStatus.Open &&
    !hasPermissions([Authorities.MOVIMENTATION_WORKORDER_OPENED_EDIT_ITEM]);
  const isDisableEditItem = props.item.disableEdit;
  const editPermission = hasPermissions([
    Authorities.MOVIMENTATION_WORKORDER_EDIT_ITEM,
  ]);
  const hasChildren = !!props.item.children?.length;
  const isClosed = complement?.status === WorkOrderComplementStatus.Closed;
  const isCancelled =
    complement?.status === WorkOrderComplementStatus.Cancelled;

  const hasPermission =
    hasChildren ||
    isDisableEditItem ||
    isAuthorized ||
    isOpen ||
    isClosed ||
    isCancelled ||
    !editPermission ||
    props.permission;

  return (
    <span
      style={{
        fontWeight:
          props.item.type === WorkOrderItemType.Kit ||
          props.item.type === WorkOrderItemType.Benefit ||
          props.item.type === WorkOrderItemType.Bosch
            ? 'bold'
            : 'normal',
        width: '100%',
      }}
      onClick={() => {
        if (hasPermission) return;

        if (props?.onClick) props.onClick();
      }}
      className={hasPermission ? undefined : 'item-input'}
    >
      {props.children}
    </span>
  );
}
